/**
 * Business type definitions — used in registration dropdown.
 * Purely informational metadata (no module filtering).
 */
const BUSINESS_TYPES = {
  beauty_salon: {
    label: 'Салон краси',
    icon: '💅',
    description: 'Манікюр, педикюр, косметологія',
  },
  barbershop: {
    label: 'Барбершоп',
    icon: '💈',
    description: 'Чоловічі стрижки та догляд',
  },
  clinic: {
    label: 'Клініка / Медцентр',
    icon: '🏥',
    description: 'Медичні послуги, стоматологія',
  },
  auto_service: {
    label: 'Автосервіс',
    icon: '🔧',
    description: 'Ремонт та обслуговування авто',
  },
  shop: {
    label: 'Магазин',
    icon: '🛍',
    description: 'Роздрібна торгівля',
  },
  cafe: {
    label: 'Кафе / Ресторан',
    icon: '☕',
    description: 'Громадське харчування',
  },
  other: {
    label: 'Інше',
    icon: '🏢',
    description: 'Довільний тип бізнесу',
  },
};

export default BUSINESS_TYPES;
